import {setup} from '../../snippets/node';
import comment from '../../snippets/comment';
import {CreateShellCommand} from '../../../components/left-col';

export const steps = {
  setup,
  create: {},
  'payment-methods': {},
  'line-items': {},
  mode: {},
  redirect: {},
  urls: {},
  'run-server': {
    Component: CreateShellCommand('npm start'),
  },
};

export default ({
  keys,
  merchant,
  client,
  activePrice,
  checkoutMode,
  demo: {paymentMethods},
}) => `{+setup}${comment && comment(merchant)}
const stripe = require('stripe')('${keys.secret}');
{/setup}
const express = require('express');
const app = express();
app.use(express.static('public'));

const YOUR_DOMAIN = '${
  client === 'react'
    ? 'http://localhost:3000/checkout'
    : 'http://localhost:4242'
}';

app.post('/create-checkout-session', async (req, res) => {
  {+create}
  const {span response create}session{/span} = await stripe.checkout.sessions.create({
    {?customize prefill-email}
    customer_email: 'customer@example.com',
    {/prefill-email}
    {?customize submit-button}
    submit_type: 'donate',
    {/submit-button}
    {?customize address}
    billing_address_collection: 'auto',
    shipping_address_collection: {
      allowed_countries: ['US', 'CA'],
    },
    {/address}
    {+line-items}
    line_items: [
      {
        ${
          activePrice
            ? `price: '${activePrice.id}'`
            : `// TODO: replace this with the \`price\` of the product you want to sell
        price: '{{PRICE_ID}}'`
        },
        quantity: 1,
      },
    ],
    {/line-items}
    {+payment-methods}
    payment_method_types: [
      ${
        paymentMethods.length
          ? paymentMethods.map((key) => `'${key}',`).join('\n      ')
          : '// TODO: pass at least one option here'
      }
    ],
    {/payment-methods}
    {+mode}
    mode: '${checkoutMode}',
    {/mode}
    {+urls}
    success_url: \`\${YOUR_DOMAIN}${
      client === 'react' ? '?success=true' : '/success.html'
    }\`,
    cancel_url: \`\${YOUR_DOMAIN}${
      client === 'react' ? '?canceled=true' : '/cancel.html'
    }\`,
    {/urls}
    {?automatic-tax automatic-tax-param}
    automatic_tax: {enabled: true},
    {/automatic-tax-param}
  });

  {+redirect}
  res.redirect(303, session.url)
  {/redirect}
  {/create}
});

app.listen(4242, () => console.log('Running on port 4242'));`;
